import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { RemovedUserFragment } from "gql/graphql";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";
import React, { memo, ReactNode } from "react";
import colors from "app/colors";
import DistributionGroupTooltipContent from "./distribution-group-tooltip-content";

interface IProps {
  id: string;
  accessUserIds?: string[];
  removedUserList?: RemovedUserFragment[];
  openDelay?: number;
  children: ReactNode;
}

const DistributionGroupTooltip: React.FC<IProps> = ({
  id,
  accessUserIds,
  removedUserList,
  openDelay,
  children,
}) => {
  const { distributionGroupsById } = useDistributionGroups();
  const distributionGroup = distributionGroupsById[id];

  if (!distributionGroup) return null;

  return (
    <Popover trigger="hover" openDelay={openDelay} isLazy>
      <PopoverTrigger>{children}</PopoverTrigger>
      <Portal>
        <PopoverContent
          backgroundColor={colors.white}
          color={colors.grayMain}
          borderRadius={16}
          p={3}
          w={394}
          maxH={600}
          overflowY="auto"
        >
          <DistributionGroupTooltipContent
            id={id}
            accessUserIds={accessUserIds}
            removedUserList={removedUserList}
          />
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default memo(DistributionGroupTooltip);
